import React, { useRef } from "react";

import { Button, type ButtonProps } from "components/ui/button";
import { Input } from "components/ui/input";

interface FileUploadButtonProps extends Omit<ButtonProps, "onChange" | "id"> {
  inputId: string;
  accept: string;
  onFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const FileUploadButton: React.FC<FileUploadButtonProps> = ({
  inputId,
  accept,
  onFileChange,
  children,
  ...buttonProps
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const openFilePicker = (): void => {
    inputRef.current?.click();
  };

  return (
    <>
      <div hidden>
        <Input
          id={inputId}
          ref={inputRef}
          type="file"
          accept={accept}
          onChange={onFileChange}
          tabIndex={-1}
        />
      </div>
      <Button type="button" onClick={openFilePicker} {...buttonProps}>
        {children}
      </Button>
    </>
  );
};
